import {
	AccountBalanceRounded,
	CompareArrowsRounded,
	DashboardRounded,
	GroupsRounded,
	Inventory2Rounded,
	LeaderboardRounded,
	StoreRounded,
	Timelapse,
	TrendingUpRounded,
} from "@mui/icons-material";
import HomeRounded from "@mui/icons-material/HomeRounded";
import CollectionsRoundedIcon from "@mui/icons-material/CollectionsRounded";
import GirlIcon from '@mui/icons-material/Girl';
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";

import { Route } from "react-router-dom";
import Reports from "./Reports";
import DashboardNavCollapsableWithCustomNav from "components/Layout/DashboardNavCollapsableWithCustomNav/DashboardNavCollapsableWithCustomNav";
import { arrType, datatypes, inputTypes } from "data/globalData";
import { rootProtectedPath } from "data/authData";
import moment from "moment";

export const darkblueColor = "#325864ff";
export const midBlueColor = "#92a6ad";
export const lightBlueColor = "#b2cbd3";

export const darkRedColor = "#a94139";
export const midRedColor = "#d8534aff";
export const midOrangeColor = "#dd3a1dff";
export const midPinkColor = "#f72d3eff";

export const midMaroonColor = "#d14f76ff";

export const lightBrownColor = "#c1b3a7";
export const lightYellowColor = "#e2d6c5";
export const offWhiteColor = "#fff3e7";

export const growthGreenColor = "#40ee5dff";
export const midGreenColor = "#677768";

export const midgrayColor = "#636260ff";
export const lightgreencolor = "#98dbb5ff";
export const midgreencolor = "#3f5c41ff";
export const darkgreenColor = "#2c4134ff";

export const getColumnValue = (row, obj) => {
	if (row?.data_type === datatypes.DATE.key) {
		return moment(obj?.[row.key]).format("DD-MM-YYYY") || "--";
	} else if (row.input_type == inputTypes.MULTIPLE_SELECT.key) {
		return obj?.[row.key]?.join(", ") || "--";
	} else {
		return obj?.[row.key] || "--";
	}
};
export const reportsBackgroundColor = "#F2F3F4";

export const reportsDashboardSideNavList = {
	// HOME: { name: "Home", key: "HOME", display: true, icon: <HomeRounded /> },
	SALE: {
		name: "Sale",
		key: "SALE",
		icon: <TrendingUpRounded />,
		display: true,
		types: {
			// summary: {
			// 	name: "Summary",
			// 	key: "summary",
			// 	icon: <StoreRounded />,
			// 	display: true,
			// },
			thor_live_sale: {
				name: "THOR Live Sale",
				key: "thor_live_sale",
				display: true,
				icon: <CollectionsRoundedIcon />,
			},
			rareism_live_sale: {
				name: "RAREISM Live Sale",
				key: "rareism_live_sale",
				display: true,
				icon: <GirlIcon />,
			},
		},
	},
	// INVENTORY: { name: "Inventory", key: "INVENTORY", display: true, icon: <Inventory2Rounded /> },
	EFFICENCY: {
		name: "Efficency",
		key: "EFFICENCY",
		display: true,
		icon: <Timelapse />,
		types: {
			// EBO: {
			// 	name: "EBO",
			// 	key: "EBO",
			// 	icon: <StoreRounded />,
			// 	display: true,
			// 	types: {
			// 		SAME_STORE_GROWTH: {
			// 			name: "SAME STORE GROWTH",
			// 			key: "SAME_STORE_GROWTH",
			// 			icon: <DashboardRounded />,
			// 			display: true,
			// 		},
			// 		STAFF_COUNT: { name: "STAFF COUNT", key: "STAFF_COUNT", icon: <DashboardRounded />, display: true },
			// 		INVENTORY_INDEX: { name: "INVENTORY INDEX", key: "INVENTORY_INDEX", icon: <DashboardRounded />, display: true },
					// 	RETURNS_BEHAVIOUR: {
					// 		name: "RETURNS BEHAVIOUR",
					// 		key: "RETURNS_BEHAVIOUR",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	SELL_THROUGH: { name: "SELL THROUGH ", key: "SELL_THROUGH", icon: <DashboardRounded />, display: true },
					// 	MRP_WISE_CONTRIBUTION: {
					// 		name: "MRP WISE CONT.",
					// 		key: "MRP_WISE_CONTRIBUTION",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	REPEAT_BEH_CAT_LEVEL: {
					// 		name: "REPEAT BEH ON CAT LEVEL",
					// 		key: "REPEAT_BEH_CAT_LEVEL",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	INTERNAL_MARKET_SHARE_PERCENT: {
					// 		name: "INTERNAL MARKET SHARE %",
					// 		key: "INTERNAL_MARKET_SHARE_PERCENT",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	CASH_CARD_REPORT: {
					// 		name: "CASH & CARD REPORT",
					// 		key: "CASH_CARD_REPORT",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	INVENTORY_VIEW: { name: "INVENTORY VIEW", key: "INVENTORY_VIEW", icon: <DashboardRounded />, display: true },
					// 	TGT_VS_ACHV_OF_SALES: {
					// 		name: "TGT VS ACHV OF SALES",
					// 		key: "TGT_VS_ACHV_OF_SALES",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	LOSS_OF_CUST_ABOLUTE_STR_WISE_L2L_STRUCTURE: {
					// 		name: "LOSS OF CUST ABSOLUTE STR WISE L2L STRUCTURE",
					// 		key: "LOSS_OF_CUST_ABOLUTE_STR_WISE_L2L_STRUCTURE",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	SO_PENDING_REPORT: {
					// 		name: "SO PENDING REPORT",
					// 		key: "SO_PENDING_REPORT",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	LEFT_REP_OF_STORES: {
					// 		name: "LEFT REP OF STORES",
					// 		key: "LEFT_REP_OF_STORES",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	FASHIONABILITY_TREND: {
					// 		name: "FASHIONABILITY TREND",
					// 		key: "FASHIONABILITY_TREND",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	ST_Comparison_LY_TY: {
					// 		name: "ST Comparison LY TY",
					// 		key: "ST_Comparison_LY_TY",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
			// 	},
			// },
			// MBO: { name: "MBO", key: "MBO", display: true, icon: <StoreRounded /> },
			// LFS: { name: "LFS", key: "LFS", display: true, icon: <StoreRounded /> },
			// D2C: { name: "D2C", key: "D2C", display: true, icon: <StoreRounded /> },
			// MARKETPLACE: { name: "MARKETPLACE", key: "MARKETPLACE", display: true, icon: <LanguageRounded /> },
			PICTORIAL_ST: { name: "Sell Through Pictorial ", key: "PICTORIAL_ST", display: true, icon: <CollectionsRoundedIcon /> },
			// SO_TRACKER: { name: "SO Tracker ", key: "SO_TRACKER", display: true, icon: <CollectionsRoundedIcon /> },
			INVENTORY_SNAPSHOT: { name: "Inventory Snapshot", key: "INVENTORY_SNAPSHOT", display: true, icon: <CollectionsRoundedIcon /> },
			DISPATCH_MAILER: { name: "Partner Dispatch Mailer", key: "DISPATCH_MAILER", display: true, icon: <CollectionsRoundedIcon /> },
			PDF_TO_EXCEL: { name: "Line Sheet Convertor", key: "PDF_TO_EXCEL", display: true, icon: <PictureAsPdfRoundedIcon /> },
		},
	},
	ALLOCATION: {
		name: "Allocation",
		key: "ALLOCATION",
		display: true,
		icon: <DashboardRounded />,
		types: {
			SIZE_CONTRIBUTION: { name: "Size Contribution", key: "SIZE_CONTRIBUTION", display: true, icon: <CollectionsRoundedIcon /> },
		},
	},
	// COMPARISON: { name: "Comparison", key: "COMPARISON", display: true, icon: <CompareArrowsRounded /> },
	// MARKETING: { name: "Marketing", key: "MARKETING", display: true, icon: <LeaderboardRounded /> },
	// CUSTOMER: { name: "Customer", key: "CUSTOMER", display: true, icon: <GroupsRounded /> },
	// FINANCE: { name: "Finance", key: "FINANCE", display: true, icon: <AccountBalanceRounded /> },
};

// Recursive function to build routes
export const generateReportsRoutesFromServiceTree = (service, rootPath) => {
	if (service?.types)
		return (
			<Route key={service.key} path={service.key}>
				{service.types &&
					Object.keys(service.types).map((childKey) =>
						generateReportsRoutesFromServiceTree(service.types[childKey], rootPath)
					)}
			</Route>
		);
	else
		return (
			<Route
				key={service.key}
				path={service.key}
				element={
					<DashboardNavCollapsableWithCustomNav
						drawerList={reportsDashboardSideNavList}
						searchParamName="tab"
						navSpace={0}
						service={service}
						pathName={service.key}
						rootPath={rootPath}
						baseUrl={rootProtectedPath}
						sx={{ background: reportsBackgroundColor }}
					/>
				}>
				<Route index element={<Reports />} />
			</Route>
		);
};

export const groupByoptions = {
	hour: {
		name: "Hour",
		key: "hour",
	},
	day: {
		name: "Day",
		key: "day",
	},
};
export const moreOptions = {
	export: {
		name: "Export",
		key: "export",
	},
};
export const filterColArry = [
	// {
	// 	name: "Group BY",
	// 	key: "group_by",
	// 	input_type: inputTypes.SELECT.key,
	// 	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	// 	data: {},
	// 	data_type: datatypes.STRING.key,
	// 	sort_no: 1,
	// 	group: "",
	// 	placeholder: "",
	// 	default_value: "",
	// 	select_options: {
	// 		type: arrType,
	// 		list: [
	// 			{ name: "Hour", key: "hour" },
	// 			{ name: "Day", key: "day" },
	// 		],
	// 	},
	// },
	{
		name: "Product Vendor",
		key: "product_vendor",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// // { name: allOption, key: allOption },
				// { name: "RARE RABBIT", key: "RARE RABBIT" },
				// { name: "RAREISM", key: "RAREISM" },
				// { name: "RAREONES", key: "RAREONES" },
			],
		},
	},
	{
		name: "Product Type",
		key: "product_type",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// // { name: allOption, key: allOption },
				// { name: "RARE RABBIT", key: "RARE RABBIT" },
				// { name: "RAREISM", key: "RAREISM" },
				// { name: "RAREONES", key: "RAREONES" },
			],
		},
	},
	{
		name: "Sales Channel",
		key: "sales_channel",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// // { name: allOption, key: allOption },
				// { name: "RARE RABBIT", key: "RARE RABBIT" },
				// { name: "RAREISM", key: "RAREISM" },
				// { name: "RAREONES", key: "RAREONES" },
			],
		},
	},
];

export const lightOrangeColor = "#D9C7B4";

export const COLOR_PALETTE = {

  // Row 3
  coolSlate: "#7D899E",
  softTaupe: "#BDB0A2",

  steelBlue: "#96A5BB",
  beigeMist: "#F2E5D6",

  dustySage: "#98AF98",
  oliveTan: "#C1A771",
  dustyTeal: "#9AB3B6",
//   forestMint: "#74AA8B",
//   brightOrangeRed: "#F2644C",

  // Row 2
  
  sageMist: "#B6CEB5",
  warmSand: "#E2C086",
  softAqua: "#B5D2D6",
//   lightGreenTea: "#8ACDA8",
//   salmonRed: "#F47B6D",

  // Row 1 (Top)
  powderBlue: "#B3C6DC",
  creamWhite: "#FFF6EE",
  paleMint: "#D1E9D0",
  softPeach: "#FFDCAE",
  iceBlue: "#CAE8EF",
//   mintPastel: "#AAD9BB",
//   coralBlush: "#F7A29C",

// Row 5 (Bottom)
  gunmetalBlue: "#4A5060",
  earthGrey: "#847A70",
  sageGrey: "#677768",
  rusticBrown: "#776347",
  charcoalTeal: "#606E73",
//   deepMoss: "#496654",
//   deepBrickRed: "#A94139",
// Row 4
//   desertBrown: "#9B845C",
//   warmGrey: "#A5988B",
//   fadedDenim: "#788991",
//   deepSlateBlue: "#656E82",
//   mossGreen: "#5D876E",
//   mutedOlive: "#7F9481",
//   brickRed: "#CD5242",
};
// Generate list from object values
// export const COLOR_PALETTE_LIST = Object.values(COLOR_PALETTE);

export const COLOR_PALETTE1 ={

	slateGray: "#6B7A8F",
	beige: "#D9C7B4",
	midBlueColor: "#92a6ad",
	lightBlueColor: "#b2cbd3",
	darkSlate: "#63747B",
	warmTaupe: "#C1B3A7",
	dustyBlue: "#92A6AD",
	sandBeige: "#E2D6C5",
	mutedOlive: "#7F9481",
	sageMist: "#B6CEB5",
	creamBeige: "#F2E5D6",
	creamWhite: "#FFF3E7",
	iceBlue: "#CAE8EF",
	paleMint: "#D1E9D0",
	sageCenter: "#8A987C",
	warmYellowishOrange: "#96845c",
}
export const COLOR_PALETTE_LIST = Object.values(COLOR_PALETTE1);


export const VENN_COLORS = {
  darkSlate: "#63747B",
  lightTeal: "#B2CBD3",
  dustyBlue: "#92A6AD",
  sandBeige: "#E2D6C5",
  warmTaupe: "#C1B3A7",
  creamWhite: "#FFF3E7",
  sageCenter: "#8A987C",
};
// Generate list from object values
export const VENN_COLORS_LIST = Object.values(VENN_COLORS);

export const DONUT_COLORS = {
  fadedDenim: "#788991",
  darkSlate: "#63747B",
  lightTeal: "#B2CBD3",
  iceBlue: "#CAE8EF",
  creamBeige: "#F2E5D6",
  sandBeige: "#E2D6C5",
  warmTaupe: "#C1B3A7",
};

// Generate list from object values
export const DONUT_COLOR_LIST = Object.values(DONUT_COLORS);

export function calculateGrowth(lastYear, thisYear) {
  if (lastYear === 0 && thisYear === 0) return 0;         // no growth if both 0
  if (lastYear === 0 && thisYear > 0) return 100;         // 100% growth from 0 baseline
  if (lastYear === 0 && thisYear < 0) return -100;        // rare case, but handle it
  return (((thisYear - lastYear) / lastYear) * 100).toFixed(1);
}

export const GrowthIcon = ({ color = "green", size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 4L4 20H20L12 4Z" />
  </svg>
);

export const DegrowthIcon = ({ color = "red", size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 20L4 4H20L12 20Z" />
  </svg>
);
